export const selectPersonalHistory = (state) => state.personalHistory;
export const selectPersonalHistoryItems = (state) => state.personalHistory.items;
export const selectPersonalHistoryLoading = (state) => state.personalHistory.loading;
export const selectPersonalHistoryError = (state) => state.personalHistory.error;
export const selectPersonalHistoryHasFetched = (state) => state.personalHistory.hasFetched;